import PropTypes from "prop-types";
import {
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";

import { ButtonV1, ModalBox } from "components";
import { APPROVED_CREDIT_HEADERS } from "../constants";
import { moneyFormat } from "utils";
import theme from "themeProvider";

const ApprovedCreditLimitsModal = ({
  open,
  onClose,
  data,
  onViewBlockedAmount,
}) => {
  const listData = Array.isArray(data) && data.length > 0 ? data : [];

  return (
    <ModalBox open={open} onCloseModal={onClose} width="85%">
      <Box p={2}>
        <Typography variant="h3" mb={3}>
          Approved credit limits
        </Typography>

        <TableContainer
          component={Paper}
          sx={{ mt: 3, borderRadius: 2, maxHeight: 450 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {APPROVED_CREDIT_HEADERS.map((header, index) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {listData.map((item, index) => {
                const isFrozen = item.isCreditBlocked === true;
                const statusLabel = isFrozen ? "Frozen" : "Unfrozen";

                return (
                  <TableRow
                    key={item.creditLimitRefId || index}
                    hover
                    sx={{
                      "& td": {
                        py: 2.5,
                      },
                    }}
                  >
                    <TableCell>{item?.creditType || "-"}</TableCell>
                    <TableCell>{item?.creditLimitRefId || "-"}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {item?.creditDueDay || "-"}
                    </TableCell>
                    <TableCell>
                      {moneyFormat(item?.creditSanctioned || 0)}
                    </TableCell>
                    <TableCell>
                      {moneyFormat(item?.creditUtilised || 0)}
                    </TableCell>
                    <TableCell>
                      {moneyFormat(item?.creditAvailable || 0)}
                    </TableCell>
                    <TableCell>
                      {moneyFormat(item?.creditBlocked || 0)}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        color: isFrozen
                          ? theme.palette.error.dark
                          : theme.palette.success.dark,
                      }}
                    >
                      {statusLabel}
                    </TableCell>
                    <TableCell>
                      <ButtonV1
                        variant="outlined"
                        title="View blocked amount"
                        size="small"
                        onClick={() => onViewBlockedAmount?.(item)}
                        sx={{
                          py: 1,
                          px: 3,
                          whiteSpace: "nowrap",
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </ModalBox>
  );
};

ApprovedCreditLimitsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.array,
  onViewBlockedAmount: PropTypes.func,
};

export default ApprovedCreditLimitsModal;
